import { render, staticRenderFns } from "./FormSelectBox.vue?vue&type=template&id=4de9bb56&scoped=true"
import script from "./FormSelectBox.vue?vue&type=script&lang=js"
export * from "./FormSelectBox.vue?vue&type=script&lang=js"
import style0 from "./FormSelectBox.vue?vue&type=style&index=0&id=4de9bb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de9bb56",
  null
  
)

export default component.exports